<template>
  <div>
        <shelvesStore2 :isshow.sync='productFlag' v-if="productFlag" :excludeList='tableData' @onClick='saveret' :config="config" :keyItem='keyItem'>
            <el-table-column
            :prop="keyItem"
            label="货品id"
            width="150">
          </el-table-column>
          <el-table-column
            prop="name"
            label="货品名称"
            min-width="150"
            >
          </el-table-column>
          <el-table-column  :label="$t('message.商品图片')" width="300" >
              <template slot-scope="scope">
                  <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover" @show='showimg'>
                    <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                    <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                  </el-popover>
                  <span v-else>{{$t('message.无')}}</span>
              </template>
            </el-table-column>
        </shelvesStore2>
       <el-button
            :disabled="!isModify"
            size="medium"
            round
             @click="selectProduct"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
    <div style="height:20px"></div>
     <el-table
          ref="table"
          :data="tableData"
          stripe
          border
          style="width: 100%">
          <el-table-column
            fixed
            label="No."
            type="index"
            width="55">
          </el-table-column>
          <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" round type="normal" icon="el-icon-delete" @click="deleteTableDate(scope,scope.index)" :disabled="!isModify"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column
            :prop="keyItem"
            label="货品ID"
            show-overflow-tooltip
            align="center"
            width="250">
          </el-table-column>
          <el-table-column
            prop="name"
            label="货品名称"
            show-overflow-tooltip
            align="center"
            min-width="150"
            >
          </el-table-column>

          <el-table-column  label="产品图片344*min（100）" width="250" align="center">
            <template slot-scope="scope">
                <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover">
                  <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                  <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                </el-popover>
                <span v-else>{{$t('message.无')}}</span>
            </template>
          </el-table-column>
    </el-table>
  </div>
</template>

<script>
import shelvesStore2 from "@/components/productStore/shelvesStore2";
export default {
    name:'goodsSelection',
    components: {
    shelvesStore2,
  },
     props: {
    // 是否使用复选
    isModify: {
      type: Boolean,
      default: true,
    },
    tableData:{
        type:Array,
        default:[]
    }
     },
    data(){
        return {
            productFlag:false,
            config:{
                slot:true,
                // posturl:'/manage/shop/getpageshoplist'
                posturl:'/manage/commodity/getcommoditylist'
            },
            keyItem:'commodityid'
        }
    },
    methods:{
        selectProduct(){

            this.productFlag=true
        },
        deleteTableDate(e,r){
            console.log(e,r)
            let v=JSON.parse(JSON.stringify(this.tableData))
            v.splice(e.$index,1)
            this.$emit('update:tableData',v)

        },
        saveret(e){
            // this.tableData=this.tableData.concat(e.sel)

            let v=JSON.parse(JSON.stringify(this.tableData))
            this.$emit('update:tableData',v.concat(e.sel))
        },

    },
    mounted(){
        console.log(this.tableData)
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/elementSelect/goodsSelection.vue